export const PT_BR = {
    values: {
        'Loading...': 'Carregando...',
        'Data reprocessing': 'Reprocessamento de dados',
        Reprocessing_: 'Reprocessamento',
        SEC: 'SEG',
        'Real Time': 'Tempo Real',
        'Data reprocessing completed successfully': 'O reprocessamento de dados foi finalizado com sucesso',
        'Only Performance KPIs': "Apenas 'Performance KPIs'",
        'Reprocessing Rig Floor KPI data.': 'Reprocessando dados de Rig Floor KPI',
        'Waiting for performance reprocessing': "Aguardando o reprocessamento de dados de 'KPI performance'.",
        Waiting: 'Aguardando',
        Initializing: 'Inicializando',
        'No Rig Floor KPI data being reprocessed.': 'Nenhuma dado Rig Floor KPI sendo reprocessado',
        'Rig Floor reprocessing has finished successfully!':
            'O reprocessamento dos dados Rig Floor foi finalizado com sucesso',
        'Channels Configuration for Rig Floor': 'Configurações de canais para Rig Floor',
        'CHANNELS INTERPOLATION': 'INTERPOLAÇÃO DE CANAIS',
        'INTERPOLATION FREQUENCY': 'FREQUÊNCIA DA INTERPOLAÇÃO',
        'Real-time event production has been terminated': 'A produção dos dados de KPIs foi encerrada',
        'No equipment selected': 'Nenhum equipamento selecionado',
        'Rig Floor Equipments': 'Equipamentos de Rig Floor',
        'Riser Equipments': 'Equipamentos de Riser',
        'Rig Floor channels config': 'Configuração de canais do Rig Floor',
        'Riser channels config': 'Configuração de canais do Riser',
        'Rig Floor channels configurations': 'Configurações de canais do Rig Floor',
        'Riser channels configurations': 'Configurações de canais do Riser',
        'Channels interpolation': 'Interpolação de canais',
        'Rig Floor Status': 'Status do Rig Floor',
        'Generating Rig Floor KPI data.': 'Gerando dados de Rig Floor KPI',
        'No Rig Floor KPI data being generated.': 'Nenhum dado de Rig Floor KPI sendo gerado.',
        'Performance KPIs production started successfully!':
            "A produção dos dados de KPIs de 'Performance' foi iniciada!",
        'Performance and RIG Floor KPIs production started successfully!':
            "A produção dos dados de KPIs de 'Performance' e 'RIG Floor' foi iniciada!",
        'MAX DELTA WITHOUT INTERPOLATION': 'MÁXIMA VARIAÇÃO SEM INTERPOLAÇÃO',
        'Here you will see the equipment associated with this RIG and a Hydratong archetype.':
            'Aqui você verá o equipamento associado a esta sonda e um arquétipo Hydratong.',
        'Here you will see the equipment associated with this RIG and a Hydraracker archetype.':
            'Aqui você verá o equipamento associado a esta sonda e um arquétipo Hydraracker.',
        'Here you will see the equipment associated with this RIG and a Top Drive archetype.':
            'Aqui você verá o equipamento associado a esta sonda e um arquétipo Top Drive.',
        Riser: 'Riser',
        'Here you will see the equipment associated with this RIG and a RRT archetype.':
            'Aqui você verá o equipamento associado a esta sonda e um arquétipo RRT.',
        'Here you will see the equipment associated with this RIG and a Catwalk archetype.':
            'Aqui você verá o equipamento associado a esta sonda e um arquétipo Catwalk.',
        "It's not possible to configure channels while Reprocessing is Running. You need to stop Reprocessing to access Channels Configurations.":
            'Não é possível configurar os canais enquanto o reprocessamento está sendo executado. Você precisa para o reprocessamento para acessar a configuração de canais.',
        'Applied successfully!': 'Aplicado com sucesso!',
        'Error saving!': 'Erro ao salvar!',
        'The event time range does not align with a stand or overlaps with multiple stands.':
            'O intervalo de tempo do evento não está alinhado com um stand ou se sobrepõe a múltiplos stands.',
        'No stand was found for the event time range.':
            'Não foi encontrado um stand para o intervalo de tempo do evento.',
        'A KPI with this indicator already exists for the associated stand.':
            'Já existe um KPI com este indicador para o stand associado.',
        'was created successfully': 'foi criado com sucesso',
        'was updated successfully': 'foi atualizado com sucesso',
        failed: 'falhou',
        reason: 'razão',
        'Events created successfully.': 'Eventos criados com sucesso.',
        'Events updated successfully.': 'Eventos atualizados com sucesso.',
        'Creating events...': 'Criando eventos...',
        'Deleting events...': 'Deletando eventos...',
        'Updating events...': 'Atualizando eventos...',
        'An unexpected error has occurred.': 'Ocorreu um erro inesperado.',
        'Events deleted successfully': 'Eventos deletados com sucesso',
        'Failed to delete events': 'Falhou em deletar os eventos',
        Loading: 'Carregando',
        Success: 'Sucesso',
        Error: 'Erro',
        Clear: 'Limpar',
        Apply: 'Aplicar',
        Verify: 'Verificar',
        Verified: 'Verificado',
        Start: 'Início',
        End: 'Fim',
        Duration: 'Duração',
        'Overlaps with': 'Sobrepõe com',
        'New row': 'Nova linha',
        'End time out of selected range': 'Hora de término fora do intervalo selecionado',
        'End time must be after start time': 'A hora de término deve ser após a hora de início',
        'Invalid date/time': 'Data/hora inválida',
        'Start time out of allowed range': 'Hora de início fora do intervalo permitido',
        'Add row': 'Adicionar linha',
        'Please select an asset': 'Por favor selecione um ativo',
        'Correct errors before saving': 'Corrija os erros antes de salvar',
        'SELECT KPIS': 'Selecionar KPIs',
        'KPI selected': 'KPI selecionado',
        'KPIs selected': 'KPIs selecionados',
        'KPIs that are not present on the selected timestamp will be disabled on this filter.':
            'KPIs que não estão presentes no timestamp selecionado serão desabilitados neste filtro.',
        'No KPIs in the selected time frame': 'Nenhum KPI no período selecionado',
        APPLY: 'Aplicar',
        'Restore default': 'Restaurar padrão',
        'The amount of KPIs loaded is limited to 100 for better visualization and performance':
            'A quantidade de KPIs carregados é limitada a 100 para melhor visualização e desempenho',
        'The indicator is missing from the KPI event.': 'O indicador está ausente no evento KPI.',
        'The KPI indicator is unknown.': 'O indicador do KPI é desconhecido.',
        'The current event indicator is not aligned with the associated stand indicator.':
            'O indicador do evento atual não está alinhado com o indicador do stand associado.',
        'Invalid start or end timestamp.': 'Timestamp de início ou fim inválido.',
        'All events verified successfully': 'Todos os eventos verificados com sucesso',
        'Some events have validation errors': 'Alguns eventos possuem erros de validação',
        'Verification failed': 'Falha na verificação',
        'An unexpected error occurred during verification': 'Ocorreu um erro inesperado durante a verificação',
        Displaying: 'Exibindo',
        'KPIs (covering': 'KPIs (cobrindo',
        'hours out of': 'horas de um total de',
        'hours selected). Reduce the time interval to access all KPIs for the period.':
            'horas selecionadas). Reduza o intervalo de tempo para acessar todos os KPIs do período.'
    }
}
